<template>
  <div>
    Музыканты
  </div>
</template>

<script>
  export default {
    name: "Musicians"
  }
</script>

<style scoped>

</style>
